export const TOKEN_TTL_MS = 300_000; // 5 min — matches the backend access-token TTL
export const TOKEN_REFRESH_BUFFER_MS = 10_000; // refresh 10 s before expiry

// Last-resort cap on how long the router guard waits for auth bootstrap. If restore() ever
// stalls (e.g. a /auth/me call that never settles), the guard proceeds instead of hanging
// on a blank screen.
export const BOOTSTRAP_READY_TIMEOUT_MS = 15_000;

// Max wait to acquire an auth Web Lock held by another context. Must stay below
// BOOTSTRAP_READY_TIMEOUT_MS so a restore-time claim fails before the boot watchdog fires.
export const AUTH_LOCK_WAIT_TIMEOUT_MS = 10_000;

// Bound requests made under auth locks and during restore. The manager accepts a replayed
// refresh token for only 10 s, so timing out a rotation that still completes strands a stale
// token (logout on the next refresh). 55 s lets slow refreshes land, under the 60 s LB cutoff.
export const AUTH_REQUEST_TIMEOUT_MS = 55_000;

export const AUTH_BROADCAST_CHANNEL = 'wp-auth';
export const AUTH_REFRESH_LOCK_SESSION = 'wp-auth-session-refresh';
export const AUTH_REFRESH_LOCK_APP_PREFIX = 'wp-auth-app-refresh-';
